<template>
    <ac-modal :title="'Price Tiers'" ref="modalRef">
        <template v-if="widgetReady">
            <price-tiers-summary :companyId="companyId" :planId="planId"></price-tiers-summary>
        </template>
    </ac-modal>
</template>

<script>
    import PriceTiersSummary from "./PriceTiersSummary.vue";

    export default {
        name: "PriceTiersSummaryModal",
        components: {PriceTiersSummary},
        data() {
            return {
                widgetReady: false,
                planId: null,
                companyId: null
            }
        },
        methods: {
            async showModal(plan) {
                this.planId = plan.planId;
                this.companyId = plan.companyId;
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            cancel() {
                this.$refs.modalRef.close();
            },
        },
    }
</script>

<style scoped>
</style>